// React
import React from 'react';
// External
import {
    Button, Col, Form, Image, Modal, Row
} from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
// Internal
import imageFallback from 'assets/images/image-not-available.png';
import Selector from 'components/shared/atoms/Selector/Selector';
import ProductSelector from 'components/shared/atoms/ProductSelector/ProductSelector';
import { createBooking, editBooking } from 'services/booking';
import ProductService from 'services/product';
import BrandService from 'services/brand';
import Product from 'models/Product';
import Booking from 'models/Booking';
import Engraving from 'models/Engraving';
import { updateBooking, updateEngraving } from 'stores/actions';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Styles
import './styles.scss';
import CustomTextarea from 'components/shared/atoms/CustomTextarea/CustomTextarea';
import { isEmptyObject } from 'jquery';


const AMOUNT_OF_ITEMS = 1;

/**
 * @param {Object} props.show - Style to applied to the component, this overwrites the height and width props
 * @param {Function} props.onHide - Path or Route object to navigate to
 * @param {Function} props.onAddClick - Function to handle extra actions when the user click add
 * @param {boolean} props.divider - Boolean to display the divider between header and body, default is true.
 */
class ProductModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productSelected: null,
            productSelectedList: [this.props.product],
            levelListArr: [],
            levelListArrPackage: {},
            engravingProduct: null,
            engravingProductList: [],
            addEngraving: true,
            imageSelectedIndex: 0,
            errors: [],
            brandName: '',
            productCounter: 0,
            parentProductType: 'Product',
            selectedValue: {parent:'',child: ''},
            parent_id: null,
            engravingConfig: {
                maxLines: 0,
                maxCharacters: 0,
            },
            engravingText: '',
            childSelected: null,
            parentSelected: null,
            parentObject: {},
            imageSelectedProductId: '',
            primaryImageSelected: false,
            selectedOptionsWithPrimaryImage: [],
            selectedProductsWithPrimaryImage: [],
            isPrimaryProduct: false,
            primaryParents: {},
            primaryImageSelectedBaseParent: '',
            parentPrevValue: {},
            childPrevValue: {},
            dropdownClicked: false,
            dropdownClickedValue: '',
            isSubmitted: false,
            optionalWithoutDropdown: [],
            hideInPortalModal: false,
            infoIconClass: 'popover__title',
            hasUserErrorConfig: false,
            vetSupplyId: '',
            addButtonDisabled: true,
            getProductOptionFirstResponse: false,
            editIds: [],
            pendingRequests: [],
            isUpdated: false
        };
        this.headers = ['', 'OPTION', 'PRICE', ''];
        this.getLocalProductsConfig();
        this.getLevelListArr(this.props.isEdit ? this.props.product.producttemplateIdC : this.props.product.id, 0);
        this.getBrandContact();
        this.getPrimaryImage(null, true, this.props.product.id);
    }

    componentDidMount() {
        document.getElementsByClassName('modal-title')[0].scrollIntoView(); 
        if (this.props.product.name.includes('Cremation Package')){
            setTimeout(() => {
                this.setState({addButtonEnabled: true});
            }, 5000);       
        }
        
        //check if allProductFormat is not empty
        if(!isEmpty(this.props.product.allProductFormat)) {
            // set value to editIds
            this.setState({editIds: this.props.product.allProductFormat.length > 1 ? this.props.product.allProductFormat.slice(-1) : this.props.product.allProductFormat})
        }
        if(!isEmpty(this.props.product.childProductsCartFormat) && this.props.isEdit) {
            this.props.product.childProductsCartFormat.forEach((element) => {
                if(!isEmpty(element.engravingText)) {
                    this.setState({engravingText: element.engravingText})
                }
            })
        }

    }

    componentDidUpdate(prevProps) {
        // Only when the value changes the status update will be triggered
        if (this.props.product && prevProps.product !== this.props.product) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                productSelected: null,
                productSelectedList: [this.props.product],
                levelListArr: [],
                levelListArrPackage: {},
                errors: []
            });
            this.getLevelListArr(this.props.product.id, 0);
        }
    }

    /**
     * Gets the contact info of the brand
     */
    getBrandContact() {
        BrandService.getBrand()
            .then((response) => {
                this.setState({brandName: response.data.name});
            }).catch((err) => {
                console.error(err);
            });
    }

    /**
     * [getPrimaryImage handles product image logic]
     *
     * @param   {string}  productId
     * @param   {array}  options
     * @param   {integer}  key
     * @param   {integer}  childParent
     * @param   {integer}  childKey
     *
     * @return  {void}
     */
    async getPrimaryImage(parentId, isPrimaryProduct, productId, options = [], key = null, childParent = null, childKey = null) {
        // product info condition
        let validSelection = true;
        // if image is already selected and productId is not in selected options
        if (this.state.imageSelectedProductId == productId || this.state.isPrimaryProduct) {
            return;
        }
        // get product image
        const response = await ProductService.getPrimaryImage(productId)
            .then((response) => {
                // if primary product has primary image
                if (isPrimaryProduct) {
                    if (response.data && !this.state.isPrimaryProduct) {
                        this.setState({primaryImageSelected: true, primaryProductImage: response.data, imageSelectedProductId: productId, isPrimaryProduct: true});
                    }
                    return;
                }
                // get ids of options
                let optionIds = [];
                // loop options
                options.forEach((option) => {
                    // append ids to array
                    optionIds.push(option.value);
                })
                // init
                let keyRank = key * 10;
                let childKeyRank = childKey == null ? -1 : childKey;
                childKeyRank += 1;
                let rankValue = keyRank + childKeyRank;
                let primaryImageSelectedBaseParent = '';
                // if not the primary product
                if (!isPrimaryProduct) {
                    // if parent id is the primary product
                    if (parentId === this.props.product.id) {
                        this.state.primaryParents[productId] = [];
                    } else {
                        // if parent id is in primary parents
                        if (this.state.primaryParents.hasOwnProperty(parentId)) {
                            // add to array if not yet in array
                            if (!this.state.primaryParents[parentId].includes(productId)){
                                this.state.primaryParents[parentId].push(productId);
                            }
                            // get id of base parent
                            primaryImageSelectedBaseParent = parentId;
                        } else { // if grandchild
                            // look for the value of the parent
                            for (const key in this.state.primaryParents) {
                                // if parent id is in array
                                if (this.state.primaryParents[key].includes(parentId)) {
                                    // if product id is not yet in the array
                                    if (!this.state.primaryParents[key].includes(productId)) {
                                        this.state.primaryParents[key].push(productId);
                                    }
                                    // get id of base parent
                                    primaryImageSelectedBaseParent = key;
                                }
                            }
                        }
                    }
                }
                // if products with primary image but not selected is not empty
                if (!isEmptyObject(this.state.selectedProductsWithPrimaryImage)) {
                    // if product id is in selected Options of selected products, remove from selected
                    this.setState({selectedProductsWithPrimaryImage: this.state.selectedProductsWithPrimaryImage.filter(function(product){
                        if (!product.selectedOptionsWithPrimaryImage.includes(productId)) {
                            return product;
                        }
                    })})
                }
                // remove selected image if parent was changed
                if (optionIds.includes(this.state.imageSelectedParentId) || optionIds.includes(this.state.primaryImageSelectedBaseParent)) {
                    // remove image selected
                    this.setState({primaryImageSelected: false});
                }
                // remove from selected products with primary image if base parent was changed
                this.setState({selectedProductsWithPrimaryImage: this.state.selectedProductsWithPrimaryImage.filter(function(product){
                    if (!optionIds.includes(product.primaryImageSelectedBaseParent)) {
                        return product;
                    }
                })})
                // if product id is in selected Options, remove image
                if (this.state.selectedOptionsWithPrimaryImage.includes(productId)) {
                    // remove image selected
                    this.setState({primaryImageSelected: false});
                    // check primary image of already selected products
                    if (!isEmptyObject(this.state.selectedProductsWithPrimaryImage)) {
                        // get lowest rank value product
                        var lowestRankValueProduct = this.state.selectedProductsWithPrimaryImage.reduce(function(prev, curr) {
                            return prev.rankValue < curr.rankValue ? prev : curr;
                        })
                        // set state
                        this.setState({primaryImageSelected: true,
                            primaryProductImage: lowestRankValueProduct.primaryProductImage,
                            imageSelectedProductId: lowestRankValueProduct.imageSelectedProductId,
                            imageSelectedProductInfo: lowestRankValueProduct.imageSelectedProductInfo,
                            imageSelectedParentId: lowestRankValueProduct.imageSelectedParentId,
                            primaryImageSelectedBaseParent: lowestRankValueProduct.primaryImageSelectedBaseParent,
                            selectedOptionsWithPrimaryImage: lowestRankValueProduct.selectedOptionsWithPrimaryImage});

                    }
                }
                // product info condition
                if (this.state.imageSelectedProductInfo != undefined && (key > this.state.imageSelectedProductInfo.key || (key == this.state.imageSelectedProductInfo.key && childParent > this.state.imageSelectedProductInfo.childParent)
                    || (key == this.state.imageSelectedProductInfo.key && childParent == this.state.imageSelectedProductInfo.childParent && childKey != null && childKey > this.state.imageSelectedProductInfo.childKey))) {
                    validSelection = false;
                }
                // if there is no current image
                if (!this.state.primaryImageSelected || (validSelection && response.data)) {
                    // if product has a primary image
                    if (response.data) {
                        // set state
                        this.setState({selectedOptionsWithPrimaryImage: optionIds});
                    }
                    // set state
                    this.setState({
                        primaryImageSelected: response.data ? true : false,
                        primaryProductImage: response.data,
                        imageSelectedProductId: response.data ? productId : '',
                        imageSelectedParentId: response.data ? parentId : '',
                        primaryImageSelectedBaseParent: response.data ? primaryImageSelectedBaseParent : '',
                        imageSelectedProductInfo: {key: key,
                            childParent: childParent,
                            childKey: childKey
                        }
                    });
                    // put to selected products if primary image is already set
                    if (this.state.primaryImageSelected) {
                        this.setState(prevState => ({
                            selectedProductsWithPrimaryImage: [...prevState.selectedProductsWithPrimaryImage, {
                                imageSelectedProductInfo: {key: key, childParent: childParent, childKey: childKey},
                                primaryProductImage: response.data,
                                imageSelectedProductId: productId,
                                selectedOptionsWithPrimaryImage: optionIds,
                                imageSelectedParentId: parentId,
                                primaryImageSelectedBaseParent: primaryImageSelectedBaseParent,
                                rankValue: rankValue,
                            }]
                        }));
                    }
                }
                // if has primary and not valid selection
                if (this.state.primaryImageSelected && response.data && !validSelection && this.state.imageSelectedProductId != productId) {
                    // if not empty
                    if (!isEmptyObject(this.state.selectedProductsWithPrimaryImage)) {
                        let validProduct = true;
                        // check if current product is valid
                        this.state.selectedProductsWithPrimaryImage.forEach((product) => {
                            // not selected condition
                            if (key == product.imageSelectedProductInfo.key && (product.imageSelectedProductInfo.childKey == null || childKey > product.imageSelectedProductInfo.childKey)) {
                                validProduct = false;
                            }
                        });
                        // add if valid
                        if (validProduct) {
                            this.setState(prevState => ({
                                    selectedProductsWithPrimaryImage: [...prevState.selectedProductsWithPrimaryImage, {
                                    imageSelectedProductInfo: {key: key, childParent: childParent, childKey: childKey},
                                    primaryProductImage: response.data,
                                    imageSelectedProductId: productId,
                                    selectedOptionsWithPrimaryImage: optionIds,
                                    imageSelectedParentId: parentId,
                                    primaryImageSelectedBaseParent: primaryImageSelectedBaseParent,
                                    rankValue: rankValue,
                                }]
                            }));
                        }
                    } else {
                        // add product
                        this.setState(prevState => ({
                                selectedProductsWithPrimaryImage: [...prevState.selectedProductsWithPrimaryImage, {
                                imageSelectedProductInfo: {key: key, childParent: childParent, childKey: childKey},
                                primaryProductImage: response.data,
                                imageSelectedProductId: productId,
                                selectedOptionsWithPrimaryImage: optionIds,
                                imageSelectedParentId: parentId,
                                primaryImageSelectedBaseParent: primaryImageSelectedBaseParent,
                                rankValue: rankValue,
                            }]
                        }));
                    }
                }
            });
        return;
    }


    /**
     * This will remove the child of the on change product.
     *
     * @param {*} productId
     * @param {*} uuid
     * @param {*} parentId
     * @param {*} baseId
     * @param {*} previousValue
     */
    removeProductsOnChange(productId, uuid, parentId, baseId, previousValue, isParent) {
        let hasNextPreviousValue = false;
        let errorsToBeDeleted = [];
        do {
            if (!isEmpty(previousValue)) {
                let productToBeDeleted = [];
                Object.keys(this.state.levelListArrPackage).forEach(mainLevelKey => {
                    let indexOfParentProduct = Object.keys(this.state.levelListArrPackage[mainLevelKey])
                    .findIndex(secondKey => {
                        if (secondKey.includes(parentId)) {
                            return true;
                        } else if (this.state.levelListArrPackage[mainLevelKey][secondKey][0]['baseId'].includes(parentId)) {
                            return true;
                        }

                        return false;
                    });

                    let indexOfProduct = Object.keys(this.state.levelListArrPackage[mainLevelKey])
                    .map((secondKey, i) => secondKey.includes(previousValue) ? i : this.state.levelListArrPackage[mainLevelKey][secondKey][0]['baseId'].includes(previousValue) ? i : -1)
                    .filter(index => index !== -1)

                    if (indexOfParentProduct !== -1) {
                        let currentKey = Object.keys(this.state.levelListArrPackage[mainLevelKey])[indexOfParentProduct]
                        if (this.state.levelListArrPackage[mainLevelKey][currentKey].length > 1) {
                            let optionCurrentIndex = this.state.levelListArrPackage[mainLevelKey][currentKey].findIndex(option => {
                                if (option.value === productId) {
                                    return true;
                                } else if (option.baseId === productId) {
                                    return true;
                                }

                                return false;
                            });
                            let optionPreviousIndex = this.state.levelListArrPackage[mainLevelKey][currentKey].findIndex(option => {
                                if (option.value === previousValue) {
                                    return true;
                                } else if (option.baseId === previousValue) {
                                    return true;
                                }

                                return false;
                            });

                            if (optionCurrentIndex !== -1) {
                                this.state.levelListArrPackage[mainLevelKey][currentKey][optionCurrentIndex]['isDefaultValue'] = true;
                            }
                            if (optionPreviousIndex !== -1) {
                                this.state.levelListArrPackage[mainLevelKey][currentKey][optionPreviousIndex]['isDefaultValue'] = false;
                            }
                        }
                    }

                    if (indexOfProduct.length > 0) {
                        let keyToDelete = [];
                        indexOfProduct.forEach(prodIdx => {
                            let currentKey = Object.keys(this.state.levelListArrPackage[mainLevelKey])[prodIdx]
                            
                            if (this.state.levelListArrPackage[mainLevelKey][currentKey].length > 1) {
                                let optionIndex = this.state.levelListArrPackage[mainLevelKey][currentKey].findIndex(option => option.isDefaultValue === true);
                                if (optionIndex !== -1) {
                                    previousValue = this.state.levelListArrPackage[mainLevelKey][currentKey][optionIndex]['value'];
                                }
                            } else {
                                previousValue = this.state.levelListArrPackage[mainLevelKey][currentKey][0]['value'];
                            }

                            // This will get the child key based on previous value
                            let previousValueIndex = Object.keys(this.state.levelListArrPackage[mainLevelKey]).findIndex(key => key.includes(previousValue));
                            if (previousValueIndex !== -1) {
                                let previousValueKey = Object.keys(this.state.levelListArrPackage[mainLevelKey])[previousValueIndex];
                                // FPC-1545 - [issue 1] issue fixed to not delete some dropdowns (Garden Urn)
                                keyToDelete.push(previousValueKey);
                            }

                            keyToDelete.push(currentKey);
                        })

                        if (keyToDelete.length > 0) {
                            keyToDelete.forEach(prodKey => {
                                productToBeDeleted.push(prodKey)
                            });
                        }

                        hasNextPreviousValue = true;
                    } else {
                        hasNextPreviousValue = false;
                    }
                });

                if (productToBeDeleted.length > 0) {
                    // This will get the removed child id.
                    // So we can use also to remove in errors data.
                    productToBeDeleted.forEach(productId => {
                        if (this.state.levelListArrPackage[productId] !== undefined) {
                            Object.keys(this.state.levelListArrPackage[productId]).forEach(key => {
                                errorsToBeDeleted.push(key);
                            });

                            errorsToBeDeleted = [...productToBeDeleted, ...errorsToBeDeleted];
                        }
                    });

                    Object.keys(this.state.levelListArrPackage).forEach(mainLevelKey => {
                        productToBeDeleted.forEach(keyToDelete => {
                            // We need to delete also the field that be removed in errors
                            let index = this.state.errors.findIndex(value => value === keyToDelete);
                            if (index !== -1) {
                                this.state.errors.splice(index, 1)
                            }
                            if (this.state.parentPrevValue[keyToDelete] !== undefined) {
                                delete this.state.parentPrevValue[keyToDelete];
                            } 
                            if (this.state.childPrevValue[keyToDelete] !== undefined) {
                                delete this.state.childPrevValue[keyToDelete];
                            }
                            if (this.state.optionalWithoutDropdown[keyToDelete] !== undefined) {
                                delete this.state.optionalWithoutDropdown[keyToDelete];
                            }
                            if (mainLevelKey === keyToDelete && this.state.levelListArrPackage[mainLevelKey] !== undefined) {
                                delete this.state.levelListArrPackage[mainLevelKey];
                            }
                            if (this.state.levelListArrPackage[mainLevelKey] !== undefined) {
                                delete this.state.levelListArrPackage[mainLevelKey][keyToDelete];
                            }
                        });
                    });
                }
            }

        } while(hasNextPreviousValue);

        // Remove the gathered product id
        // from removed field in errors data.
        let errorsToDelete = [...new Set(errorsToBeDeleted)];
        if (errorsToDelete.length > 0) {
            errorsToDelete.forEach(errorProdId => {
                let index = this.state.errors.findIndex(value => value === errorProdId);
                if (index !== -1) {
                    this.state.errors.splice(index, 1)
                }
            });
        }

        this.state.productCounter = Object.keys(this.state.levelListArrPackage).length;
    }

    /**
     * This will re arrange the ordering of final
     * level list data structure
     */
    arrangeLevel() {
        let newLevelListArrayPackage2 = {};

        Object.keys(this.state.levelListArrPackage).forEach(mainLevelKey => {
            newLevelListArrayPackage2[mainLevelKey] = {};
            Object.keys(this.state.levelListArrPackage[mainLevelKey]).forEach(secondLevelKey => {
                let selectedSecondLevelValue = null;
                let selectedBaseId = null;
                if (this.state.levelListArrPackage[mainLevelKey][secondLevelKey].length > 1) {
                    let secondIndex = this.state.levelListArrPackage[mainLevelKey][secondLevelKey].findIndex(data => {
                        if (data.isDefaultValue === true) {
                            return true;
                        }
                        return false;
                    });

                    let currentIdx = secondIndex;
                    if (currentIdx !== -1) {
                        selectedSecondLevelValue = this.state.levelListArrPackage[mainLevelKey][secondLevelKey][currentIdx]['value'];
                        selectedBaseId = this.state.levelListArrPackage[mainLevelKey][secondLevelKey][currentIdx]['baseId'];
                    }
                } else {
                    selectedSecondLevelValue = this.state.levelListArrPackage[mainLevelKey][secondLevelKey][0]['value']
                    selectedBaseId = this.state.levelListArrPackage[mainLevelKey][secondLevelKey][0]['baseId']
                }

                let levelIndexByBaseId = [];
                Object.keys(this.state.levelListArrPackage[mainLevelKey]).forEach((key, index) => {
                    if (this.state.levelListArrPackage[mainLevelKey][key][0]['baseId'].includes(selectedSecondLevelValue)) {
                        levelIndexByBaseId.push(index);
                    }
                });

                let levelIndexByValue = Object.keys(this.state.levelListArrPackage[mainLevelKey]).findIndex(key => key.includes(selectedSecondLevelValue));

                if (newLevelListArrayPackage2[mainLevelKey][selectedSecondLevelValue] === undefined) {
                    if (!isEmpty(levelIndexByBaseId)) {
                        let indexOfCurrentSecondLevel = Object.keys(newLevelListArrayPackage2[mainLevelKey]).findIndex(secondKey => secondKey === secondLevelKey);
                        newLevelListArrayPackage2[mainLevelKey][secondLevelKey] = this.state.levelListArrPackage[mainLevelKey][secondLevelKey];
                        levelIndexByBaseId.forEach(index => {
                            let currentKey = Object.keys(this.state.levelListArrPackage[mainLevelKey])[index];

                            if (indexOfCurrentSecondLevel > -1) {
                                let toEntries = Object.entries(newLevelListArrayPackage2[mainLevelKey]);
                                let dataToInsert = [
                                    currentKey,
                                    this.state.levelListArrPackage[mainLevelKey][currentKey]
                                ];
                                // FPC-1545: [issue 2] issue fixed to not re order dropdowns (Paw Casting)
                                // toEntries.splice(indexOfCurrentSecondLevel+1, 0, dataToInsert);
                                let fromEntries = Object.fromEntries(toEntries);
                                newLevelListArrayPackage2[mainLevelKey] = fromEntries;
                            } else {
                                newLevelListArrayPackage2[mainLevelKey][currentKey] = this.state.levelListArrPackage[mainLevelKey][currentKey]
                            }
                        });
                    } else if(levelIndexByValue !== -1) {
                        let currentKey = Object.keys(this.state.levelListArrPackage[mainLevelKey])[levelIndexByValue];
                        newLevelListArrayPackage2[mainLevelKey][secondLevelKey] = this.state.levelListArrPackage[mainLevelKey][secondLevelKey];
                        newLevelListArrayPackage2[mainLevelKey][currentKey] = this.state.levelListArrPackage[mainLevelKey][currentKey];
                    } else {
                        let indexOfCurrentSecondLevel = Object.keys(newLevelListArrayPackage2[mainLevelKey]).findIndex(secondKey => secondKey === secondLevelKey);
                        if (indexOfCurrentSecondLevel === -1) {
                            Object.keys(newLevelListArrayPackage2[mainLevelKey]).forEach((secondKey, index) => {
                                if (newLevelListArrayPackage2[mainLevelKey][secondKey].length > 1) {
                                    let optionIndex = newLevelListArrayPackage2[mainLevelKey][secondKey].findIndex(option => secondLevelKey.includes(option.value));
                                    if (optionIndex !== -1) {
                                        indexOfCurrentSecondLevel = index;
                                    }
                                } else if(secondLevelKey.includes(newLevelListArrayPackage2[mainLevelKey][secondKey][0]['value'])) {
                                    indexOfCurrentSecondLevel = index;
                                }
                            });
                        }

                        if (indexOfCurrentSecondLevel > -1) {
                            let toEntries = Object.entries(newLevelListArrayPackage2[mainLevelKey]);
                            let dataToInsert = [
                                secondLevelKey,
                                this.state.levelListArrPackage[mainLevelKey][secondLevelKey]
                            ];
                            toEntries.splice(indexOfCurrentSecondLevel+1, 0, dataToInsert);
                            let fromEntries = Object.fromEntries(toEntries);
                            newLevelListArrayPackage2[mainLevelKey] = fromEntries;
                        } else {
                            newLevelListArrayPackage2[mainLevelKey][secondLevelKey] = this.state.levelListArrPackage[mainLevelKey][secondLevelKey];
                        }

                    }
                }
            })
        });

        this.setState({levelListArrPackage: newLevelListArrayPackage2})
    }

    /**
     * This will arrange product selected list by
     * ordering of levelListArrPackage
     */
    arrangeProductSelectedList() {
        let newProductSelectedList = [];
        if (!isEmpty(this.state.productSelectedList) && Object.keys(this.state.levelListArrPackage).length > 0) {
            Object.keys(this.state.levelListArrPackage).forEach(mainLevelKey => {
                let productByMainLevel = this.state.productSelectedList.filter(product => {
                    if (mainLevelKey.includes(product['id'])) {
                        return true;
                    } else if (mainLevelKey.includes(product['parentId'])) {
                        return true;
                    }

                    return false;
                });

                newProductSelectedList = [...newProductSelectedList, ...productByMainLevel];

                Object.keys(this.state.levelListArrPackage[mainLevelKey]).forEach(secondLevelKey => {
                    let productBySecondLevel = this.state.productSelectedList.filter(product => {
                        if (secondLevelKey.includes(product['id'])) {
                            return true
                        } else if(secondLevelKey.includes(product['parentId'])) {
                            return true;
                        }

                        return false;
                    });

                    newProductSelectedList = [...newProductSelectedList, ...productBySecondLevel];
                });
            });
        }

        newProductSelectedList = newProductSelectedList.map(item => item)
        .filter((value, index, self) => self.indexOf(value) === index)
        this.setState({productSelectedList: newProductSelectedList});
    }


    /**
     * Gets Product data to render in dropdown
     */
    getLevelListArr(productId, levelIndex, uuid = null, child = false , parentId, baseId, previousValue = '', uniqueProductId = '', hideInPortalModal, isParent = false, count = this.state.productCounter , type = this.state.parentProductType) {
        if (!productId) {
            return;
        }
        const petWeight = this.props.booking.pet.weight;
        // Get the Product from API
        ProductService.getProductOptions(productId,type,parentId,baseId, hideInPortalModal)
            .then((response) => {
                // remove value from pending request if a response is received
                this.setState(prevState => ({
                    pendingRequests: prevState.pendingRequests.filter(
                        (value) => value !== productId
                      ),
                }), () => {
                    // check if there is no pending request
                    if (isEmpty(this.state.pendingRequests)) {
                        // enable button
                        this.setState({addButtonDisabled: false});
                    } else {
                        this.setState({addButtonDisabled: true});
                    }
                });

                // Check if count is 0
                if (count === 0) {
                    this.state.parentProductType = response.data['product'].cstm.type_c
                }
                // Variables
                let products=[]
                let productsPackage = {};
                let hasChild = false
                // If the parent is Package
                response.data['filteredproducts'].forEach((packageProduct, index) => {
                let responseProducts
                let parentProduct = {}
                let parent
                if (packageProduct.cstm !== undefined) {
                    responseProducts = [Product(packageProduct)]
                } else {
                    responseProducts = packageProduct.map((item) => Product(item));
                }
                if (!isEmpty(response.data['parents'])) {
                    parentProduct = response.data['parents'].find(x => {
                        if (!isEmpty(packageProduct[0].pivot)) {
                            return x.id === packageProduct[0].pivot.parent_product_id
                        }

                        return false;
                    })
                    if(!isEmpty(parentProduct) && !parentProduct.name.includes('Invisible')) {
                        parent = parentProduct.name
                    }
                }

                let alreadyHasDefaultValue = false;
                // Check if productpackage has ID
                if (!uuid && !productsPackage.hasOwnProperty(productId)) {
                    productsPackage[productId] = {}
                }
                if (uuid && !productsPackage.hasOwnProperty(uuid)) {
                    productsPackage[uuid] = {}
                }
                // Populate the product object
                const products = responseProducts.map((item) => {
                    let parentId = !isEmpty(item.pivot) ? item.pivot.parentProductId : item.id
                    let isEditDefaultValue = false
                    let editIds = this.state.editIds
                    const isDefaultValue = (Number(petWeight) >= Number(item.cstm.minWeightC) && Number(petWeight) <= Number(item.cstm.maxWeightC));
                    if(this.props.isEdit) {
                        isEditDefaultValue = editIds[0].includes(item.id);
                    }
                    const newItem = {
                        name: item.name,
                        value: item.id,
                        product: Product(item),
                        isDefaultValue: isDefaultValue && !alreadyHasDefaultValue,
                        isValueChanged: false,
                        isSelected: false,
                        parent: parent,
                        hideInPortalModal: item.hideInPortalModal === null ? 0 : item.hideInPortalModal,
                        parentId : parentId,
                        orderBy: item.cstm.orderByC,
                        orderKey: count,
                        isEditDefaultValue: isEditDefaultValue,
                        packageId: item.packageId,
                        baseId: item.baseId,
                        isSpecialOrder: item.cstm.specialOrderC
                    };

                    if (isDefaultValue) {
                        alreadyHasDefaultValue = true;
                    }
                    return newItem;
                })


                let pivotProdId

                    if (packageProduct.cstm !== undefined) {
                        if(packageProduct.pivot) {
                            pivotProdId = packageProduct.pivot.parent_product_id
                        } else {
                            pivotProdId = packageProduct.id
                        }
                        productsPackage[uuid ? uuid : productId][pivotProdId] = products.sort((a, b) => a.orderBy - b.orderBy)
                        hasChild = true
                    } else {
                        if(packageProduct.length) {
                            if(packageProduct[0].pivot) {

                                pivotProdId = packageProduct[0].pivot.parent_product_id === productId ? packageProduct[0].pivot.parent_product_id+"parent" : packageProduct[0].pivot.parent_product_id;

                            } else {
                                pivotProdId = packageProduct[0].id
                            }
                            productsPackage[uuid ? uuid : productId][pivotProdId] = products.sort((a, b) => a.orderBy - b.orderBy)
                            hasChild = true
                        }
                        else {
                            productsPackage = packageProduct
                        }
                    }
                })

                if (isEmpty(response.data['parents']) && this.state.optionalWithoutDropdown[uniqueProductId] !== undefined) {
                    delete this.state.optionalWithoutDropdown[uniqueProductId];
                }
    
                if(!isEmpty(response.data['parents']) &&
                   response.data['parents'].length === 1 &&
                   !response.data['parents'][0].name.includes('Invisible') &&
                   response.data['parents'][0].optionalStatus === 1) {
                    this.state.optionalWithoutDropdown[uniqueProductId] = response.data['parents'][0].name;
                }

                this.setState((prevState) => {
                    this.state.productCounter = this.state.productCounter + 1
                    let productCount = this.state.productCounter
                    let productSelectedList = [];
                    let levelListArr;
                    let levelListArrPackage;
                    let productSelected = response.data['product'];
                    let selectedIndex = ''
                    levelListArrPackage = prevState.levelListArrPackage
                    productSelectedList = prevState.productSelectedList
                    selectedIndex = productSelectedList.findIndex(selectedItem => selectedItem.parentId === productSelected.parentId)
                    if(selectedIndex > -1) {
                            productSelectedList[selectedIndex]= productSelected
                    } else {
                        productSelectedList.push(productSelected)
                    }

                    if(hasChild) {
                        if (!uuid) {
                            levelListArrPackage = Object.assign(levelListArrPackage, productsPackage)
                        }
                        else {
                            if (levelListArrPackage.hasOwnProperty(uuid) && !child) {
                                levelListArrPackage[uuid] = productsPackage[uuid]
                            }
                            else {
                                // Push the child in the parent when Package is selected
                                if (count === 1) {
                                    this.state.parentObject = levelListArrPackage[parentId]
                                    levelListArrPackage[parentId] = { ...this.state.parentObject, ...productsPackage[uuid]}
                                } else {
                                    levelListArrPackage[uuid] = { ...levelListArrPackage[uuid], ...productsPackage[uuid]}
                                }
                            }
                        }
                    }

                    return {
                        levelListArrPackage,
                        levelListArr,
                        productSelected,
                        productSelectedList
                    };
                },
                );
            })
            .then(() => {
                this.arrangeLevel();
            })
            .then(() => {
                this.arrangeProductSelectedList();
                this.setState({ engravingProduct: null }, () => {
                    this.getProductEngraving();
                });
            })
            .catch((error) => {
                console.error(error);
            });
    }

    getProductEngraving = async () => {
        if (this.state.productSelectedList.length === 0) {
            return;
        }

        try {
            // Loop through the selected products to find and set the product that requires engraving as the engraving product
            this.state.productSelectedList.forEach(selectedProduct => {
                if (selectedProduct && selectedProduct.cstm && (selectedProduct.cstm.requiresEngravingC || selectedProduct.cstm.requires_engraving_c)) {
                    this.setState({ 
                        engravingProduct: Product(selectedProduct),
                        addEngraving: true 
                    });
                }
            })
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    getStockAvailability() {
        let currentHasStockAvailability = false;
        this.state.productSelectedList.forEach((item) => {
            let hasStockAvailability = false;
            if (item) {
                let availableStock = 0;
                let minStock = 0;
                if (this.state.brandName === 'WA LWD') {
                    availableStock = item.cstm.waLwdAvailableStockC;
                    minStock = item.cstm.waLwdMinStockC;
                } else if (this.state.brandName === 'VIC EDH') {
                    availableStock = item.cstm.vicEdhAvailableStockC;
                    minStock = item.cstm.vicEdhMinStockC;
                } else if (this.state.brandName === 'SA EDH') {
                    availableStock = item.cstm.saEdhAvailableStockC;
                    minStock = item.cstm.saEdhMinStockC;
                } else if (this.state.brandName === 'AW EDH') {
                    availableStock = item.cstm.awEdhAvailableStockC;
                    minStock = item.cstm.awEdhMinStockC;
                }
                hasStockAvailability = (
                    ((item.cstm.sendToUnleashedC === 1) && !(item.cstm.hasInventoryC === 1))
                    || (
                        (item.cstm.sendToUnleashedC === 1)
                        && (item.cstm.hasInventoryC === 1)
                        && (availableStock > minStock)
                    )
                );
            }

            if (hasStockAvailability) {
                currentHasStockAvailability = hasStockAvailability;
            }
        });
        return currentHasStockAvailability;
    }

    /**
     * Retrieves the list of engraving products stored in the fpc_config.js file
     */
    getLocalProductsConfig() {
        fetch('../fpc_config.json')
            .then((response) => response.json())
            .then((data) => {
                this.setState({ engravingProductList: data.Config_File });
            });
    }

    updateShoppingCart = async () => {
        let { booking } = this.props;
        let strLineItemEngravingText = null;
        const product = this.state.productSelectedList[0];
        // Get booking ID
        let bookingId = localStorage.getItem('vet-supply-id') ? localStorage.getItem('vet-supply-id') : booking.id

        // Get the final selected child product
        const finalChildProduct = this.state.productSelectedList[this.state.productSelectedList.length - 1];

        const index = booking.quotedProducts.findIndex(
            (item) => {
                    // Check if this quoted product has no child products and the current selected product has no child products
                    if (item.hasOwnProperty('childProductsCartFormat') && item.childProductsCartFormat.length === 0 && this.state.productSelectedList.length === 1) {
                        // Check the quoted product's actual product id
                        return item.actualProductIdC === finalChildProduct.id
                    } else {
                        // Return false if the child products count mismatch
                        if (item.hasOwnProperty('childProductsCartFormat') && item.childProductsCartFormat.length !== this.state.productSelectedList.length - 1) {
                            return false;
                        }

                        let bEqual = true;

                        // Check if the selected products are identical
                        this.state.productSelectedList.forEach((objSelectedProduct, intIndex) => {
                            if (intIndex !== 0) {
                                if (item.hasOwnProperty('childProductsCartFormat') && objSelectedProduct.id !== item.childProductsCartFormat[intIndex - 1].id) {
                                    bEqual = true;
                                }
                            }
                        });

                        return bEqual;
                    }
            }
        );

        const hasEngravingText = this.state.addEngraving && this.state.engravingProduct && this.state.engravingText;

            let objChildProducts = {};
                if (this.state.productSelectedList.length > 1) {
                    this.state.productSelectedList.forEach((objSelectedProduct, intIndex) => {
                        let packageProductID = {}
                        if(!isEmpty(objSelectedProduct.packageProductStatus)) {
                            objSelectedProduct.packageProductStatus.forEach((objPackageProduct, packageIndex) => {
                                if(objPackageProduct.optional === 0 && objPackageProduct.activeStatus === 1 && objPackageProduct.show_in_portal === 1) {                       
                                    packageProductID[objPackageProduct.package_product.product.id] = null
                                } else if (objPackageProduct.optional === 1 && objPackageProduct.activeStatus === 1 && objPackageProduct.show_in_portal === 1) {
                                    objChildProducts[objPackageProduct.package_product.product.id] = [];
                                }
                            })
                        }
                        if (intIndex === '') {
                            // Skip index 0
                        } else {
                            let bEngravingChildProduct = hasEngravingText && objSelectedProduct.id === this.state.engravingProduct.id;
                            if (!isEmpty(objSelectedProduct.package_products)) {
                                objSelectedProduct.package_products.forEach((objectPackage, index) => {
                                    if(intIndex === 0 || intIndex === 1) {
                                        objChildProducts[objectPackage.package_product.product.id] = [];
                                    }
                                })
                            }
                            if (!isEmpty(objSelectedProduct.child_products)) {
                                if (!objChildProducts.hasOwnProperty(product.id)) {
                                    objChildProducts[product.id] = [];
                                }
                            }
                            if (objSelectedProduct.parentId) {
                                if (objChildProducts[objSelectedProduct.parentId]) {
                                    objChildProducts[objSelectedProduct.parentId].push({
                                        id: objSelectedProduct.id,
                                        baseId: objSelectedProduct.baseId,
                                        parentId: objSelectedProduct.parentId,
                                        name: objSelectedProduct.name,
                                        unit_price: objSelectedProduct.discount_price,
                                        requires_engraving: objSelectedProduct.cstm.requires_engraving_c,
                                        engraving_max_length: objSelectedProduct.cstm.max_lines_c,
                                        engraving_max_characters: objSelectedProduct.cstm.max_characters_c,
                                        has_image: !isEmpty(objSelectedProduct.cstm.engraving_base_image_c) ? 1 : 0,
                                        requires_collection: objSelectedProduct.cstm.requires_collection_c,
                                        includes_return_charge: objSelectedProduct.cstm.includes_return_charge_c,
                                        pre_cremation_instructions_c: objSelectedProduct.cstm.pre_cremation_instructions_c,
                                        post_cremation_instructions_c: objSelectedProduct.cstm.post_cremation_instructions_c,
                                        return_instructions_c: objSelectedProduct.cstm.return_instructions_c,
                                        description: objSelectedProduct.description,
                                        special_order: objSelectedProduct.cstm.special_order_c,
                                        show_in_manage_prep: objSelectedProduct.cstm.show_in_manage_prep_c,
                                        engraving_type: objSelectedProduct.cstm.engraving_type_c,
                                        order_information: objSelectedProduct.cstm.order_information_c,
                                        pricing_method_c: objSelectedProduct.cstm.pricing_method_c,
                                        engraving_text: bEngravingChildProduct ? this.state.engravingText : null,
                                        show_in_confirmation_emails_c: objSelectedProduct.cstm.show_in_confirmation_emails_c,
                                        type: objSelectedProduct.cstm.type_c,
                                        child_package_products: packageProductID
                                    });
                                } else {
                                    Object.keys(objChildProducts).forEach(key => {
                                        if(!isEmpty(objChildProducts[key].find(x => x.id === objSelectedProduct.parentId))) {
                                            if(objSelectedProduct.id !== product.id) {
                                                objChildProducts[key].push({
                                                    id: objSelectedProduct.id,
                                                    baseId: objSelectedProduct.baseId,
                                                    parentId: objSelectedProduct.parentId,
                                                    name: objSelectedProduct.name,
                                                    unit_price: objSelectedProduct.discount_price,
                                                    requires_engraving: objSelectedProduct.cstm.requires_engraving_c,
                                                    engraving_max_length: objSelectedProduct.cstm.max_lines_c,
                                                    engraving_max_characters: objSelectedProduct.cstm.max_characters_c,
                                                    has_image: !isEmpty(objSelectedProduct.cstm.engraving_base_image_c) ? 1 : 0,
                                                    requires_collection: objSelectedProduct.cstm.requires_collection_c,
                                                    includes_return_charge: objSelectedProduct.cstm.includes_return_charge_c,
                                                    pre_cremation_instructions_c: objSelectedProduct.cstm.pre_cremation_instructions_c,
                                                    post_cremation_instructions_c: objSelectedProduct.cstm.post_cremation_instructions_c,
                                                    return_instructions_c: objSelectedProduct.cstm.return_instructions_c,
                                                    description: objSelectedProduct.description,
                                                    special_order: objSelectedProduct.cstm.special_order_c,
                                                    show_in_manage_prep: objSelectedProduct.cstm.show_in_manage_prep_c,
                                                    engraving_type: objSelectedProduct.cstm.engraving_type_c,
                                                    order_information: objSelectedProduct.cstm.order_information_c,
                                                    pricing_method_c: objSelectedProduct.cstm.pricing_method_c,
                                                    engraving_text: bEngravingChildProduct ? this.state.engravingText : null,
                                                    show_in_confirmation_emails_c: objSelectedProduct.cstm.show_in_confirmation_emails_c,
                                                    type: objSelectedProduct.cstm.type_c,
                                                    child_package_products: packageProductID
                                                })
                                            }
                                        } else if (!isEmpty(objChildProducts[key].find(x => x.id === objSelectedProduct.baseId))) {
                                            objChildProducts[key].push({
                                                id: objSelectedProduct.id,
                                                baseId: objSelectedProduct.baseId,
                                                parentId: objSelectedProduct.parentId,
                                                name: objSelectedProduct.name,
                                                unit_price: objSelectedProduct.discount_price,
                                                requires_engraving: objSelectedProduct.cstm.requires_engraving_c,
                                                engraving_max_length: objSelectedProduct.cstm.max_lines_c,
                                                engraving_max_characters: objSelectedProduct.cstm.max_characters_c,
                                                has_image: !isEmpty(objSelectedProduct.cstm.engraving_base_image_c) ? 1 : 0,
                                                requires_collection: objSelectedProduct.cstm.requires_collection_c,
                                                includes_return_charge: objSelectedProduct.cstm.includes_return_charge_c,
                                                pre_cremation_instructions_c: objSelectedProduct.cstm.pre_cremation_instructions_c,
                                                post_cremation_instructions_c: objSelectedProduct.cstm.post_cremation_instructions_c,
                                                return_instructions_c: objSelectedProduct.cstm.return_instructions_c,
                                                description: objSelectedProduct.description,
                                                special_order: objSelectedProduct.cstm.special_order_c,
                                                show_in_manage_prep: objSelectedProduct.cstm.show_in_manage_prep_c,
                                                engraving_type: objSelectedProduct.cstm.engraving_type_c,
                                                order_information: objSelectedProduct.cstm.order_information_c,
                                                pricing_method_c: objSelectedProduct.cstm.pricing_method_c,
                                                engraving_text: bEngravingChildProduct ? this.state.engravingText : null,
                                                show_in_confirmation_emails_c: objSelectedProduct.cstm.show_in_confirmation_emails_c,
                                                type: objSelectedProduct.cstm.type_c,
                                                child_package_products: packageProductID
                                    })
                                        }
                                      });
                                }
                            }
                            // If this is the child product with engraving, append or assign the engraving text with the child product name
                            if (bEngravingChildProduct) {
                                if (strLineItemEngravingText) {
                                    strLineItemEngravingText += `\n${objSelectedProduct.name} - ${this.state.engravingText}`;
                                } else {
                                    strLineItemEngravingText = `${objSelectedProduct.name} - ${this.state.engravingText}`;
                                }
                            }
                        }
                    });
                }
            // filter the child product to get the childe package products
            let objLineItem = {
                ...Product(product),
                actualProductIdC: product.id,
                id: null,
                quantity: AMOUNT_OF_ITEMS,
                packageProductsC: objChildProducts,
                editId: this.props.product.id
            };
            // If there is an engraving text, add it to the line item
            if (strLineItemEngravingText) {
                objLineItem['engravingText'] = strLineItemEngravingText;
            }

            booking.quotedProducts.push(objLineItem);

        
        const response = bookingId ? await editBooking(bookingId, booking.submitFormat()) : await createBooking(booking.submitFormat());
        // Check if booking ID is empty to set the created ID in local storage
        if (isEmpty(bookingId)) {
            localStorage.setItem('vet-supply-id',response.data.id)
            this.setState({vetSupplyId: response.data.id})
        }
      
        booking = Booking(response.data);
        // Removes the service type before updating the information as the service type returning is the name not the id
        this.props.updateBooking(booking);

        return booking;
    };
    saveProcess = async () => {
        this.setState({isSubmitted: true, addButtonDisabled: true});

        const engravingTextErrorIndex = this.state.errors.indexOf('engraving-text');
       
        // Add the engraving text error if there is no engraving text when the engraving text field is shown has no errors yet
        if (isEmpty(this.state.engravingText) && (this.state.engravingProduct && this.state.addEngraving)) {
            if (engravingTextErrorIndex === -1) {
                this.state.errors.push('engraving-text');
            }
        } else {
            this.state.errors = this.state.errors.filter(e => !e.includes('engraving-text'));
        }
        
        if (this.state.errors.length > 0 || this.state.hasUserErrorConfig) {
            this.setState({addButtonDisabled: false})
            return;
        }
        // Add product to cart
        const booking = await this.updateShoppingCart();
        const product = this.state.engravingProduct ? this.state.engravingProduct : this.state.productSelected;

        // If engraving is selected
        if (this.state.addEngraving && booking) {
            const engraving = Engraving({
                bookingId: booking.id,
                quotedProductId: booking.quotedProducts.find(
                    (item) => item.actualProductIdC === product.id
                ),
                productId: product.id,
                customText: this.state.engravingText,
            });
            await this.props.updateEngraving(engraving);
        }

        // Closes the modal once the booking has been updated
        this.props.onSubmitted();
    }
    onClickHandler = async () => {
        // counter for special order
        let specialOrderCounter = 0;
        // loop the selected item to check the special order
        this.state.productSelectedList.forEach((selected) => {
            if(selected.cstm.special_order_c === 1) {
                // append counter
                specialOrderCounter += 1
            }
        })
        // check if the product has special order and render the alert
        if(specialOrderCounter > 0) {
            // render alert for special order
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                    <div className='alert-body'>
                        <div className='modal-header'>
                            <div className='modal-title h4'>Special order product</div>
                            <button type='button' className='close' onClick={onClose}>
                                <span aria-hidden='true'>×</span>
                            </button>
                        </div>
                        <div className='modal-body'>
                            <p><span>Please refer to the information icon for timeframes. </span><br/></p>
                            <p><span>Once we have received this product, ashes and all chosen items will be returned together.</span><br/></p>
                            <p><span>Should you require split delivery (ashes returned first), please contact our Client Care Team.</span><br/></p>
                            <p><span><strong>Note:</strong> Additional costs may apply (e.g. for regional locations or home returns.)</span></p>
                        </div>
                        <div className='modal-footer'>
                            <button type="button" className="btn action-btn"
                            onClick={() => {
                                localStorage.setItem('is-pet-next', true);
                                this.saveProcess();
                                onClose();
                            }}>
                                <b>Continue</b>
                            </button>
                            <button type="button" className="btn action-btn"
                            onClick={() => {
                                this.setState({
                                    infoIconClass: 'popover__title__alert',
                                });
                                localStorage.setItem('is-pet-next', true);
                                onClose();
                            }}>
                                <b>Close</b>
                            </button>
                        </div>
                    </div>
                    );
                }
            });
        } else {
            this.saveProcess();
        }
    
     
    };

    /**
     * Checks if the product selected can be engraved based on the products listed in the fpc_config.json file
     */
    canEngrave(product) {
        return !!(product
            && this.state.engravingProductList.findIndex((item) => item.SugarID === product.id) >= 0
            // && product?.cstm?.requiresEngravingC
        );
    }

    hasError(uuid) {
        return this.state.errors.indexOf(uuid) >= 0;
    }

    setValue(uuid, uuid2, hideInPortalModal, isEdit) {
        let selectedValue = null;

        if (this.state.levelListArrPackage[uuid][uuid2].length > 1 && this.state.levelListArrPackage[uuid][uuid2].find((k) => (k.isEditDefaultValue === true)) !== undefined && isEdit) {
            selectedValue = this.state.levelListArrPackage[uuid][uuid2].find((k) => (k.isEditDefaultValue === true)).value;
        } else if(this.state.levelListArrPackage[uuid][uuid2].find((k) => (k.isSelected === true)) !== undefined) {
            selectedValue = this.state.levelListArrPackage[uuid][uuid2].find((k) => (k.isSelected === true)).value;
        } else if (this.state.levelListArrPackage[uuid][uuid2].length === 1) {
            selectedValue = this.state.levelListArrPackage[uuid][uuid2][0].value;
        } else if (this.state.levelListArrPackage[uuid][uuid2].length > 1 && this.state.levelListArrPackage[uuid][uuid2].find((k) => (k.isDefaultValue === true)) !== undefined) {
            selectedValue = this.state.levelListArrPackage[uuid][uuid2].find((k) => (k.isDefaultValue === true)).value;
        }
        if (isEmpty(selectedValue) && !this.state.errors.includes(uuid2)) {
            if (hideInPortalModal) {
                this.setState({hasUserErrorConfig: true})
            }
            this.state.errors.push(uuid2);
        }

        if (!isEmpty(selectedValue)) {
            let index = this.state.errors.findIndex(value => value === uuid2);
            if (index !== -1) {
                this.state.errors.splice(index, 1)
            }
        }
     
        return selectedValue;
    }
    
    // Set true the isUpdate flag when there is any changes in dropdown
    isUpdate(value, count) {
        let objectToSearchIn = this.state.editIds
        let isUpdated
        if(!isEmpty(objectToSearchIn)) {
            // Check if the string is present in the object
            isUpdated = objectToSearchIn[0].some(subArray => subArray !== null && subArray.includes(value));
        }
        if(!isUpdated && count > 0) {
            this.state.isUpdated = true;
        }
    }

    handleDropdownClicked(value) {
        this.setState({dropdownClickedValue: value});
    }

    render() {
        return (
            <>
                <Modal.Body>
                    <div className="image-col">
                        <Image
                            height="280"
                            src={
                                this.state.primaryProductImage
                                    ? this.state.primaryProductImage
                                    : imageFallback
                            }
                            onError={(evt) => {
                                evt.target.src = imageFallback;
                            }}
                        />
                        {
                            this.state.engravingProduct && this.state.addEngraving ?
                            <Row className="engraving-row">
                                <Col className="engraving-row__col">
                                    <Row className="engraving-row__label-row">
                                        <div><h6>ENGRAVING</h6></div>
                                    </Row>
                                    <Row className="engraving-row__textarea-row">
                                        <CustomTextarea
                                            className="engraving-textarea"
                                            name="engraving-text"
                                            maxLines={this.state.engravingProduct.cstm.maxLinesC}
                                            maxCharacters={this.state.engravingProduct.cstm.maxCharactersC}
                                            value={this.state.engravingText}
                                            hasError={() => {
                                                if (this.state.isSubmitted) {
                                                    return this.state.errors.indexOf('engraving-text') !== -1;
                                                }

                                                return false;
                                            }}
                                            onChange={value => {
                                                this.setState(prevState => { 
                                                    let errors = prevState.errors;

                                                    if (isEmpty(value)) {
                                                        errors.push('engraving-text');
                                                    } else {
                                                        let index = this.state.errors.findIndex(value => value === 'engraving-text');

                                                        if (index !== -1) {
                                                            this.state.errors.splice(index, 1);
                                                        }
                                                    }

                                                    return { ...prevState, engravingText: value, errors: errors };
                                                });
                                            }}
                                        />
                                    </Row>
                                </Col>

                            </Row> : null
                        }
                    </div>
                    <div className="content">
                    <h6><strong>Product Options <span className={`${this.state.hasUserErrorConfig ? 'is-invalid' : 'display-none is-invalid'}`}> - Please contact us to assist you in your booking.</span></strong></h6>
                        {
                               <Form className="product-custom-inline-form">
                               {
                                   !isEmpty(this.state.levelListArrPackage) && Object.keys(this.state.levelListArrPackage).length && Object.keys(this.state.levelListArrPackage)
                                       .filter(uuid => uuid === Object.keys(this.state.levelListArrPackage)[0])
                                       .map((uuid, key1) => (
                                       Object.keys(this.state.levelListArrPackage[uuid]).map((uuid2, key2) => (
                                           <Form.Row key={key2} >
                                               <Form.Group as={Col} controlId="parentSelection"  className={`${this.state.levelListArrPackage[uuid][uuid2][0].hideInPortalModal !== 0 ? 'control-group group-col col-10 display-none' : 'control-group group-col col-10'}`} onClick={() => this.handleDropdownClicked(uuid2)}>
                                               <h6><strong>{this.state.levelListArrPackage[uuid][uuid2][0].parent ? this.state.levelListArrPackage[uuid][uuid2][0].parent: ''}</strong></h6>
                                               <div className={`${this.state.levelListArrPackage[uuid][uuid2][0].hideInPortalModal !== 0 ? 'display-none' : ''}`}>
                                               <ProductSelector
                                                    type = {this.state.parentProductType}
                                                    options={this.state.levelListArrPackage[uuid][uuid2]}
                                                    value={!isEmpty(this.setValue(uuid,uuid2,this.state.levelListArrPackage[uuid][uuid2][0].hideInPortalModal,this.props.isEdit )) ? 
                                                        this.setValue(uuid,uuid2,this.state.levelListArrPackage[uuid][uuid2][0].hideInPortalModal, this.props.isEdit ) : 
                                                        this.props.isEdit && !isEmpty(this.setValue(uuid,uuid2,this.state.levelListArrPackage[uuid][uuid2][0].hideInPortalModal, this.props.isEdit )) ? 
                                                        this.setValue(uuid,uuid2,this.state.levelListArrPackage[uuid][uuid2][0].hideInPortalModal, this.props.isEdit) : 
                                                        ''}
                                                    placeholder="Select a product..."
                                                    name={"parentSelection"}
                                                    hasError={this.hasError(uuid2)}
                                                    isSubmitted={this.state.isSubmitted}
                                                    onChange={(value, obj) => {
                                                        this.setState({ addButtonDisabled: true });
                                                        let hideInPortalModal = this.state.levelListArrPackage[uuid][uuid2][0].hideInPortalModal;
                                                        let productIndex = this.state.levelListArrPackage[uuid][uuid2].findIndex(option => option.value === value);
                                                        let currentPrevVal = this.state.parentPrevValue[uuid2] !== undefined ? this.state.parentPrevValue[uuid2] : '';
                                                        let previousValue = currentPrevVal === value ? '' : currentPrevVal;
                                                        let parentIds = this.state.levelListArrPackage[uuid][uuid2].find(x => x.value === value)
                                                        this.state.parent_id = parentIds.parentId
                                                        this.state.selectedValue.parent = value
                                                        if (this.state.dropdownClickedValue === uuid2 && currentPrevVal === value) {
                                                            this.setState({dropdownClickedValue: ''});
                                                            // check if there is no pending request
                                                            if (isEmpty(this.state.pendingRequests)) {
                                                                // enable button
                                                                this.setState({addButtonDisabled: false});
                                                            }
                                                            return;
                                                        }
                                                        if (productIndex !== -1) {
                                                            this.state.levelListArrPackage[uuid][uuid2][productIndex]['isDefaultValue'] = true;
                                                        }
                                                        if (!isEmpty(previousValue)) {
                                                            let count = 0
                                                            if(this.props.isEdit) {
                                                                this.isUpdate(value, count + 1)
                                                            }
                                                            this.removeProductsOnChange(value, uuid2, parentIds.parentId, parentIds.baseId, previousValue, true);
                                                        }
                                                        // add to pending requests
                                                        this.setState((prevState) => ({
                                                            pendingRequests: [...prevState.pendingRequests, value],
                                                        }));
                                                        this.getLevelListArr(value,-1, uuid2, false, parentIds.parentId, parentIds.baseId, previousValue, uuid2, hideInPortalModal)
                                                        let prevVal = {
                                                                [uuid2] : value
                                                        }
                                                        this.state.parentPrevValue= {...this.state.parentPrevValue, ...prevVal};
                                                        this.getPrimaryImage(parentIds.baseId, false, value, this.state.levelListArrPackage[uuid][uuid2], key2, 0);
                                                    }}
                                                    infoIconClass = {this.state.infoIconClass}
                                                    hasDownIcon={this.state.levelListArrPackage[uuid][uuid2].length > 1}
                                                    currentOption = {this.state.levelListArrPackage[uuid][uuid2]}
                                                   />
                                               </div>                                     
                                                 
                                               </Form.Group>
                                               {
                                                   this.state.levelListArrPackage.hasOwnProperty(uuid2) && Object.keys(this.state.levelListArrPackage[uuid2]).map((childUuid, key3) => (
                                                       <Form.Group as={Col} controlId="childSelection" className={`${this.state.levelListArrPackage[uuid2][childUuid][0].hideInPortalModal !== 0 ? 'control-group group-col col-10 display-none' : 'control-group group-col col-10'}`}    onClick={() => this.handleDropdownClicked(childUuid)}>
                                                           <h6><strong>{this.state.levelListArrPackage[uuid2][childUuid][0].parent ? this.state.levelListArrPackage[uuid2][childUuid][0].parent: ''}</strong></h6>
                                                           <div className={`${this.state.levelListArrPackage[uuid2][childUuid][0].hideInPortalModal !=  0 ? 'display-none' : ''}`}>
                                                           <ProductSelector
                                                                type = {this.state.parentProductType}
                                                                options={this.state.levelListArrPackage[uuid2][childUuid]}
                                                                placeholder="Select a product..."
                                                                name={"childSelection"}
                                                                value={
                                                                    !isEmpty(this.setValue(uuid2,childUuid, this.state.levelListArrPackage[uuid2][childUuid][0].hideInPortalModal), this.props.isEdit) ? 
                                                                    this.setValue(uuid2,childUuid, this.state.levelListArrPackage[uuid2][childUuid][0].hideInPortalModal,this.props.isEdit) :
                                                                    this.props.isEdit && !isEmpty(this.setValue(uuid2,childUuid, this.state.levelListArrPackage[uuid2][childUuid][0].hideInPortalModal,this.props.isEdit))  ?
                                                                    this.setValue(uuid2,childUuid, this.state.levelListArrPackage[uuid2][childUuid][0].hideInPortalModal,this.props.isEdit) : ''
                                                                }
                                                                hasError={this.hasError(childUuid)}
                                                                isSubmitted={this.state.isSubmitted}
                                                                onChange={(value, obj) => {
                                                                    this.setState({ addButtonDisabled: true });
                                                                    let hideInPortalModal = this.state.levelListArrPackage[uuid2][childUuid][0].hideInPortalModal;
                                                                    let productIndex = this.state.levelListArrPackage[uuid2][childUuid].findIndex(option => option.value === value);
                                                                    let currentPrevVal = this.state.childPrevValue[childUuid] !== undefined ? this.state.childPrevValue[childUuid] : '';
                                                                    let previousValue = currentPrevVal === value ? '' : currentPrevVal;
                                                                    let parentIds = this.state.levelListArrPackage[uuid2][childUuid].find(x => x.value === value)
                                                                    this.state.selectedValue.child = value
                                                                    if (this.state.dropdownClickedValue === childUuid && currentPrevVal === value) {
                                                                        this.setState({dropdownClickedValue: ''});
                                                                    }
                                                                    if (productIndex !== -1) {
                                                                        this.state.levelListArrPackage[uuid2][childUuid][productIndex]['isDefaultValue'] = true;
                                                                    }
                                                                    if (!isEmpty(previousValue)) {
                                                                        let count = 0
                                                                        if(this.props.isEdit) {
                                                                            this.isUpdate(value, count + 1)
                                                                        }
                                                                        this.removeProductsOnChange(value, uuid2, parentIds.parentId, parentIds.baseId, previousValue, false);
                                                                    }
                                                                    this.setState((prevState) => ({
                                                                        pendingRequests: [...prevState.pendingRequests, value],
                                                                    }));
                                                                    this.getLevelListArr(value,-1, uuid2, true, parentIds.parentId, parentIds.baseId, previousValue, childUuid, hideInPortalModal)
                                                                    let prevVal = {
                                                                            [childUuid] : value
                                                                    }
                                                                    this.state.childPrevValue =  {...this.state.childPrevValue, ...prevVal};
                                                                    this.getPrimaryImage(parentIds.baseId, false, value, this.state.levelListArrPackage[uuid2][childUuid], key2, 1, key3);
                                                                }}
                                                                infoIconClass = {this.state.infoIconClass}
                                                                hasDownIcon={this.state.levelListArrPackage[uuid2][childUuid].length > 1}
                                                                currentOption = {this.state.levelListArrPackage[uuid2][childUuid]}
                                                           />
                                                           </div>
                                                        
                                                        
                                                       </Form.Group>
                                                   ))
                                               }
                                           </Form.Row>
                                       ))
                                   ))
                               }
                           </Form>
                        }
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    { this.state.engravingProduct
                        ? (
                            <Form.Check
                                className="engraving-checkbox"
                                type="checkbox"
                                id="engraving-checkbox"
                                label="Add Engraving"
                            >
                                <Form.Check.Input
                                    type="checkbox"
                                    name="add-engraving"
                                    defaultChecked={true}
                                    onChange={(event) => {
                                        this.setState(prev => {
                                            return {
                                                ...prev,
                                                addEngraving: event.target.checked,
                                                errors: prev.errors.filter(e => !e.includes('engraving-text'))
                                            } 
                                        });
                                    }}
                                />
                                <Form.Check.Label>
                                    Add engraving
                                </Form.Check.Label>
                            </Form.Check>
                        ) : null }
                    <Button
                        variant="primary"
                        onClick={() => {
                            this.onClickHandler();
                        }}
                        disabled={this.state.addButtonDisabled}
                    >
                        {/* {this.state.addEngraving ? 'Next - customise text' : 'Add'} */}
                        {this.state.addButtonDisabled ? <FontAwesomeIcon icon={faSpinner} className="fa-solid fa-cog fa-spin" /> : this.props.isEdit ? 'Update' : 'Add'}
                    </Button>
                </Modal.Footer>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    booking: state.booking,
    engraving: state.engraving
});

const mapDispatchToProps = (dispatch) => {
    return {
        updateBooking: (bookingObj) => dispatch(updateBooking(bookingObj)),
        updateEngraving: (engravingObj) => dispatch(updateEngraving(engravingObj))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductModal));